import type {TokenizerExtension} from 'marked';

const startMentionRegex = /^@[a-zA-Z0-9.\-_]+/;

export const mentionExtension: TokenizerExtension = {
    name: 'mention',
    level: 'inline',
    tokenizer(src) {
        const match = startMentionRegex.exec(src);

        if (!match) {
            return;
        }

        return {
            type: 'text',
            raw: match[0],
            text: match[0],
        };
    },
};
